import { twMerge } from 'tailwind-merge';

import { Button, Dialog, DialogProps } from '../ui';

import moment from 'moment';
import { resolveTheme } from '../../themes';

export const CancelUserPlanModal = ({ className, onClose, ...props }: DialogProps) => {
  const theme = resolveTheme();
  return (
    <Dialog
      onClose={onClose}
      closeOnOutsideClick={true}
      className={twMerge('backdrop:bg-modalBackdropColor rounded-2xl p-0', className)}
      {...props}
    >
      <div className="w-90 space-y-2 p-8 text-center">
        <div className="font-manrope self-stretch text-center text-xl font-bold text-gray-800">
          Sure you want to cancel your {theme.name} plan?
        </div>
        <div className="font-manrope text-center text-stone-500">
          Your account is paid up thorough {moment().set('date', 1).add(1, 'M').format('MMMM D, YYYY')} and will remain
          active until that date
        </div>
      </div>
      <div className="flex flex-col gap-2 border-t border-neutral-200 p-4">
        {/* TODO: add plan cancellation logic when this functionality will work */}
        <Button onClick={onClose} variant="secondary">
          Cancel plan
        </Button>
        <Button variant="primary" onClick={onClose}>
          Keep subscription
        </Button>
      </div>
    </Dialog>
  );
};
